import React from 'react';
/**
 * `Callout` renders a reusable callout box for informational or warning text.
 *
 * When `isWarning` is true, warning-specific CSS classes are applied and
 * `role="alert"` is set so assistive technologies announce the message
 * immediately. Informational callouts use `role="note"`.
 */

import './Callout.scss';

type CalloutProps = {
  text: string;
  isWarning?: boolean;
};

const Callout = ({ text, isWarning = false }: CalloutProps): JSX.Element => {
  const calloutClass = isWarning ? 'callout warning' : 'callout';
  const calloutInnerClass = isWarning
    ? 'callout-inner warning-inner cms'
    : 'callout-inner cms';
  const calloutRole = isWarning ? 'alert' : 'note';
  return (
    <>
      {text && (
        <div role={calloutRole} className={calloutClass}>
          <div className={calloutInnerClass}>
            <span>{text}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Callout;
